import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchCustomerOrders } from 'src/api/customer/orders';
import {
    FETCH_CUSTOMER_ORDERS,
    requestCustomerOrders,
    requestCustomerOrdersFailure,
    requestCustomerOrdersSuccess,
} from './actions';

/* Customer Orders */
function* fetchCustomerOrdersSaga(action: AnyAction): SagaIterator {
    yield put(requestCustomerOrders());

    const { error, response } = yield call(fetchCustomerOrders, action.pageable);

    if (error) yield put(requestCustomerOrdersFailure(error));
    else yield put(requestCustomerOrdersSuccess(response));
}

export function* generateFetchCustomerOrdersWatcher() {
    yield takeLatest(FETCH_CUSTOMER_ORDERS, fetchCustomerOrdersSaga);
}
